import React from 'react';
import { bool, string } from 'prop-types';
import clsx from 'clsx';

import LinearProgress from '@material-ui/core/LinearProgress';

import classes from './ProgressBar.module.css';

const ProgressBar = ({className, isBob, hidden}) => (
    <div
        className={clsx(
            classes.progressContainer,
            {
                [classes.hidden]: hidden
            },
            isBob ? classes.BobProgressContainer : className
        )}
    >
        <LinearProgress
            classes={{
                colorPrimary:    classes.linearColorPrimary,
                barColorPrimary: classes.linearBarColorPrimary
            }}
        />
    </div>
);


ProgressBar.defaultProps = {
    className: '',
    hidden:    false
};

ProgressBar.propTypes = {
    className: string,
    hidden:    bool
};

export default ProgressBar;
